import { findAll, register } from '../../../../Javascript/Sysmex/Utils'
import ContentRouter from '../../../../Javascript/Libraries/ContentRouter'

const Accordion = el => {
  const router = new ContentRouter(el, 'accordion', { clickable: 'sysmexAtomAccordionPanel_contentHeader' })
  router.init()

  const expandFirst = el.getAttribute('data-expandFirst')
  const contentHeaders = findAll('[data-contentHeader]', el)
  if (expandFirst === '1') {
    contentHeaders[0].classList.add('sysmexAtomAccordionPanel_contentHeaderActive')
  }

  contentHeaders.forEach((_, index) => {
    const header = contentHeaders[index]
    header.addEventListener('click', () => {
      const isActive = !!header.classList.contains('sysmexAtomAccordionPanel_contentHeaderActive')
      contentHeaders.forEach(function (el) {
        if (el.classList.contains('sysmexAtomAccordionPanel_contentHeaderActive')) {
          el.classList.remove('sysmexAtomAccordionPanel_contentHeaderActive')
        }
      })

      if (isActive) {
        header.classList.remove('sysmexAtomAccordionPanel_contentHeaderActive')
      } else {
        header.classList.add('sysmexAtomAccordionPanel_contentHeaderActive')
      }
    })
  })
}

register('Accordion', Accordion)
